import React from 'react'
import OfferPartnershipLabel from 'components/Common/Labels/OfferPartnershipLabel'
import OfferBadge from 'components/Common/OfferBadge'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import AspectRatio from 'components/utils/AspectRatio'
import { ImageParams } from 'components/Common/ResponsiveImage'
import PrimaryButtonPaletteProvider from 'contexts/PrimaryButtonPaletteProvider'
import ImageCarousel from 'components/Luxkit/Carousel/ImageCarousel'
import HeroOfferTileWrapper from './HeroOfferTileWrapper'
import HeroBundleAndSaveOfferDetails from './HeroBundleAndSaveOfferDetails'

interface Props {
  offer: App.BundleOffer | App.BundleOfferSummary;
  eagerLoadFirstImage?: boolean;
  offerUrl: string;
}

const imageParams: ImageParams = {
  mobileAspectRatio: '3:2',
  tabletAspectRatio: '16:9',
  desktopAspectRatio: '19:9',
  mobileWidth: '80vw',
  desktopWidth: '67vw',
  largeDesktopWidth: '764px',
  quality: 'good',
}

function HeroBundleAndSaveOfferTile(props: Props) {
  const {
    offer,
    eagerLoadFirstImage,
  } = props

  return (
    <PrimaryButtonPaletteProvider palette="default">
      <HeroOfferTileWrapper>
        <AspectRatio ratio="3:2" tabletRatio="16:9" desktopRatio="19:9" fillHeight>
          <ImageCarousel
            images={offer.images}
            imageParams={imageParams}
            eagerLoadFirstImage={eagerLoadFirstImage}
            topLeft={<OfferPartnershipLabel offer={offer} variant="icon" />}
            topRight={offer.badge && <OfferBadge badge={offer.badge} />}
          />
        </AspectRatio>
        <CSSBreakpoint max="tablet">
          <HeroBundleAndSaveOfferDetails offer={offer} isDesktop={false} />
        </CSSBreakpoint>
        <CSSBreakpoint min="desktop">
          <HeroBundleAndSaveOfferDetails offer={offer} isDesktop />
        </CSSBreakpoint>
      </HeroOfferTileWrapper>
    </PrimaryButtonPaletteProvider>
  )
}

export default HeroBundleAndSaveOfferTile
